<div class="w-auto row row-cols-12">
    <ul class="list-group p-2 m-1">
        <li class="p-1 list-group-item subheader d-block align-items-center">
            <div class="row d-flex p-1 align-items-center">  
                <div class="col-8 firstcol cursor-pointer text-truncate" (click)="sortData('name')"><span translate>Settings.OrganisationWorkgroupsSection.Name</span>
                    <div class="sorting sorting-item" *ngIf="HasWorkgroups">
                        <i class="bi bi-caret-up-fill" aria-hidden="true" [ngClass]="{'invisible': columnName === 'name' && this.descending }"></i>
                        <i class="bi bi-caret-down-fill" aria-hidden="true" [ngClass]="{'invisible': columnName === 'name' && !this.descending }"></i>
                    </div>
                </div>
                <div class="col-2 cursor-pointer text-truncate" (click)="sortData('members')"><span translate>Settings.OrganisationWorkgroupsSection.Members</span>
                    <div class="sorting sorting-item" *ngIf="HasWorkgroups">
                        <i class="bi bi-caret-up-fill" aria-hidden="true" [ngClass]="{'invisible': columnName === 'members' && this.descending }"></i>
                        <i class="bi bi-caret-down-fill" aria-hidden="true" [ngClass]="{'invisible': columnName === 'members' && !this.descending }"></i>
                    </div>
                </div>
                <div class="col-2"></div>
            </div>
        </li>
        <li class="list-group-item d-block p-1" *ngIf="NoWorkgroups">
            <div class="row d-flex p-1 align-items-center">
                <div class="col-12 firstcol text-truncate"  translate="Settings.OrganisationWorkgroupsSection.NoWorkgroups"></div>
            </div>
        </li>
        <li class="list-group-item d-block p-1" *ngFor="let workgroup of workgroups | sortBy : orderBy : columnName | textfilter : filter : columns : filterWorkgroups | slice: pageSize | slice: 0:itemsPerPage; let i = index;">
            <app-workgroupListItem [organisation]="organisation" [workgroupList]="workgroupList" [organisationWorkgroup]="workgroup" (requestRefreshWorkgroups)="refreshWorkgroups()"></app-workgroupListItem>
        </li>
    </ul>

    <div class="mt-2 mb-3 w-100">
        <ng-container *ngIf="HasWorkgroups">
            <app-page-size-picker [(ngModel)]="itemsPerPage"
                [disabled]="((filterWorkgroups && filterWorkgroups.count > 0 && filterWorkgroups.count <= 10) || (workgroups && workgroups.length <= 10))"
                [collectionSize]="filterWorkgroups && filterWorkgroups.count > 0 ? filterWorkgroups.count : filterWorkgroups.count == 0 ? 1 : workgroups && workgroups.length"
                [currentPageNumber]="currentPage" (pageChangedTo)="onPageChanged($event)">
            </app-page-size-picker>
        </ng-container>
    </div>
</div>